import { ChevronRight } from "lucide-react";
import type { ReactNode } from "react";
import { useFactory } from "../../store";
import { ColorDot } from "../status-badge";

export function RouteRow({
  label,
  description,
  stations,
  onSelect,
}: {
  label: ReactNode;
  description: string;
  stations: string[];
  onSelect: (id: string) => void;
}) {
  const { agentById } = useFactory();
  return (
    <div className="space-y-2">
      <div>
        <p className="flex items-center gap-1.5 text-sm font-medium">{label}</p>
        {description && <p className="text-xs text-muted-foreground">{description}</p>}
      </div>
      <ol className="flex flex-wrap items-center gap-1.5">
        {stations.map((id, i) => {
          const a = agentById.get(id);
          return (
            <li key={id} className="flex items-center gap-1.5">
              {i > 0 && <ChevronRight className="size-3.5 text-muted-foreground" />}
              <button
                type="button"
                onClick={() => onSelect(id)}
                className="flex items-center gap-1.5 rounded-md border bg-card px-2 py-1 text-xs font-medium shadow-xs hover:bg-muted"
              >
                {a && <ColorDot color={a.station.color} className="size-2 ring-0" />}
                {a?.name ?? id}
              </button>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
